import { render, staticRenderFns } from "./BookingChannel.vue?vue&type=template&id=620a1285&scoped=true"
import script from "./BookingChannel.vue?vue&type=script&lang=js"
export * from "./BookingChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a1285",
  null
  
)

export default component.exports